// theirs
import styled from 'styled-components'
// ours
import { TextOnlyProps } from '.'
import { breakpoints, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const textOnlyBaseClass = 'text-only'

export const StyledTextOnly = styled.div<TextOnlyProps>`
    &.${textOnlyBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        background-image: url(${(props) =>
            appendLocationSingle(
                'images',
                props.content.contentBackgroundImageSource
            )});
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        z-index: 2;

        display: grid;
        grid-template-rows: ${(props) =>
            props.doesHaveNextChapter ? '50% 50%' : 'auto'};

        .content-outer {
            justify-content: center;
            justify-items: center;
        }

        .content-inner {
            display: grid;
            height: 100%;
            justify-items: center;
            place-self: center;
        }

        .text-wrapper {
            padding: 0 1rem;
            align-self: center;
            max-width: 350px;

            @media (min-width: ${breakpoints.sm}) {
                max-width: 550px;
            }

            @media (min-width: ${breakpoints.lg}) {
                max-width: 760px;
            }

            p.text {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextColor};

                font-size: ${typography.size.s2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.s3};
                }

                @media (min-width: ${breakpoints.lg}) {
                    font-size: ${typography.size.m1};
                }
            }

            p.author {
                font-family: ${typography.type.secondary};
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: 1px;
                text-transform: uppercase;
                margin-top: 1rem;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextAuthorNameColor};
            }
        }
    }
`
